/* HomeMobileStyles.js — cinetree 모바일 메인(포스터 캐러셀) 전용. 데스크톱 미영향.
   톤: 다크 네이비 배경 + 핑크 예매 CTA (cinepictures 모바일 감성) */
import styled, { keyframes } from 'styled-components';

export const Wrap = styled.div`
  background: #16233f;
  min-height: calc(100vh - 60px);
  padding: 14px 0 28px;
  color: #fff;
`;

export const Heading = styled.div`
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #cdd8f0;
  margin: 6px 0 12px;
`;

/* 가로 스크롤-스냅 캐러셀 (모바일 네이티브 스와이프) */
export const Viewport = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
`;

export const Slide = styled.div`
  flex: 0 0 100%;
  scroll-snap-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 18px;
  box-sizing: border-box;
`;

const spin = keyframes`
  from { transform: translate(-50%, -50%) rotate(0deg); }
  to   { transform: translate(-50%, -50%) rotate(360deg); }
`;

/* 포스터 자리(크기·박스 고정) — 로딩 중 남색 자리 + 스피너 위치 기준 */
export const PosterFrame = styled.div`
  position: relative;
  width: 72%;
  max-width: 300px;
  aspect-ratio: 2 / 3;
  border-radius: 12px;
  overflow: hidden;
  background: #223056;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.45);
  cursor: pointer;
`;

/* 이미지: 로드되면 부드럽게 페이드인 */
export const Poster = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  opacity: ${(p) => (p.$loaded ? 1 : 0)};
  transition: opacity 0.35s ease;
`;

/* 다크테마 스피너 (남색 트랙 + 핑크 헤드) */
export const Spinner = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 26px;
  height: 26px;
  box-sizing: border-box;
  border: 3px solid #3c4d78;
  border-top-color: #e6186c;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: ${spin} 0.8s linear infinite;
  pointer-events: none;
`;

export const Title = styled.div`
  margin-top: 16px;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  color: #fff;
  max-width: 88%;
  line-height: 1.3;
`;

export const Rank = styled.div`
  margin-top: 6px;
  font-size: 13px;
  color: #9fb0d6;
`;

export const BookBtn = styled.button`
  margin-top: 16px;
  width: 200px;
  max-width: 70%;
  padding: 13px 0;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  background: #e6186c;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(230, 24, 108, 0.4);

  &:active { background: #c9155e; }
`;

export const Dots = styled.div`
  display: flex;
  justify-content: center;
  gap: 7px;
  margin-top: 20px;
`;

export const Dot = styled.button`
  width: ${(p) => (p.$on ? '20px' : '7px')};
  height: 7px;
  border: none;
  border-radius: 4px;
  padding: 0;
  cursor: pointer;
  background: ${(p) => (p.$on ? '#e6186c' : '#3c4d78')};
  transition: width 0.2s;
`;

export const Empty = styled.div`
  text-align: center;
  color: #8fa0c8;
  padding: 60px 20px;
  font-size: 14px;
`;

export const FootNote = styled.p`
  margin: 28px 16px 0;
  text-align: center;
  font-size: 11px;
  line-height: 1.6;
  color: #6c7da3;
`;
